var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/useAsyncEffect.tsx
import { usePromise } from "@xylabs/react-promise";
import { useEffect, useRef } from "react";
function useAsyncEffect(effect, dependencies = []) {
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  usePromise(async () => {
    await effect(() => mounted.current);
  }, dependencies);
}
__name(useAsyncEffect, "useAsyncEffect");
export {
  useAsyncEffect
};
//# sourceMappingURL=index.mjs.map